function Features() {
    return (
        <div>
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Features</h2>
            <p className="text-gray-700 mb-6">
                Discover the powerful features that make OriginsBot the perfect companion for your Origins community.
            </p>

            <div className="space-y-4">
                <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#5865F2]">
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">Full Server Logging</h3>
                    <p className="text-gray-700">
                        Comprehensive logging system that tracks deleted messages, edited messages, role assignments
                        and verification notifications. Keep a complete record of your server activity.
                    </p>
                </div>

                <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#5865F2]">
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">Force Habbo Names as Nicknames</h3>
                    <p className="text-gray-700">
                        The option to automatically set members' Discord nicknames to match their verified Habbo usernames,
                        making it easy to identify users across platforms. This can be turned on and off at thee admins will.
                    </p>
                </div>

                <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#5865F2]">
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">Custom Verified Role</h3>
                    <p className="text-gray-700">
                        Change the verified role to one you may already have on your server. Seamlessly integrate
                        OriginsBot with your existing role structure.
                    </p>
                </div>

                <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#5865F2]">
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">Verify Habbo</h3>
                    <p className="text-gray-700">
                        Simple and secure Habbo verification process. Once verified in one server, you're verified
                        across all servers using OriginsBot.
                    </p>
                </div>

                <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#5865F2]">
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">Forget Verified Habbo</h3>
                    <p className="text-gray-700">
                        Users can unlink their verified Habbo account at any time, giving them full control over
                        their verification status.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Features;